<template>
  <v-container>
    <!-- <v-row justify-md="space-between">
      <v-col cols="12" md="auto">
        <v-btn
          @click="openFormDialog"
          class="accent shadow-4 px-8"
          color="success"
          large
          rounded
        >
          Añadir Tarificador
        </v-btn>
      </v-col>
    </v-row> -->

    <!-- show-expand
        single-expand -->
    <br />

    <v-row class="justify-end align-center" style="min-height:68px">
      <v-col cols="auto">
        <v-btn
          @click="isActiveDownload = true"
          color="success"
          v-bind="attrs"
          v-on="on"
          small
          rounded
          fab
        >
          <v-icon>
            mdi-download
          </v-icon>
        </v-btn>
      </v-col>
      <!-- <v-col cols="auto">
        <v-text-field
          filled
          rounded
          dense
          :value="searchField"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-col> -->
    </v-row>

    <v-card class="shadow-1 mt-5">
      <v-data-table
        :search="search"
        :headers="headers"
        :items="pricingsList"
        item-key="id"
        :loading="isLoading"
        :options.sync="options"
        :server-items-length="totalItems"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100],
        }"
      >
        <template v-slot:[`item.name`]="{ item }">
          <v-list two-line max-width="350px" class="transparent my-0 py-0">
            <v-list-item class="px-0">
              <v-list-item-content class="d-block d-md-none mr-2">
                <v-list-item-title
                  class="primary--text text--darken-1 font-weight-medium"
                  v-html="item.user.name"
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-html="item.email"
                ></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar
                size="40"
                :color="
                  $vuetify.theme.dark
                    ? 'blue-grey darken-4'
                    : 'blue-grey lighten-5'
                "
              >
                <img
                  v-if="item.user.photo"
                  :src="item.user.photo"
                  alt="Avatar del usuario"
                />
                <v-icon color="blue-grey" v-else>mdi-account</v-icon>
              </v-list-item-avatar>

              <v-list-item-content class="d-none d-md-block ml-3">
                <v-list-item-title
                  class="primary--text text--darken-1 font-weight-medium"
                  v-html="item.user.name"
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-html="item.user.email"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>

        <template v-slot:[`item.state`]="{ item }">
          <span
            :class="item.response_question.length == 0 ? 'error--text' : ''"
            >{{
              item.response_question.length > 0 ? "Completada" : "Sin responder"
            }}</span
          >
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-hover
            v-slot:default="{ hover }"
            v-if="item.response_question.length > 0"
          >
            <v-btn
              text
              icon
              :color="hover ? 'accent' : 'blue-grey'"
              @click.stop="handleShow(item.response_question)"
            >
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </v-hover>

          <v-hover
            v-slot:default="{ hover }"
            v-if="item.response_question.length == 0"
          >
            <v-btn
              text
              icon
              :color="hover ? 'accent' : 'blue-grey'"
              @click.stop="handleComplete(item.user_id)"
            >
              <v-icon>mdi-file-document-plus-outline</v-icon>
            </v-btn>
          </v-hover>

          <!-- <v-hover v-slot:default="{ hover }">
          <v-btn
            text
            icon
            :color="hover ? 'error' : 'blue-grey'"
            @click.stop="handleDelete(item)"
          >
            <v-icon>mdi-trash-can-outline</v-icon>
          </v-btn>
        </v-hover> -->
        </template>
      </v-data-table>
    </v-card>

    <answersDialog
      v-if="isOpenDialog"
      :isActive="isOpenDialog"
      :data="userAnswers"
      @close:dialog="closeFormDialog"
    ></answersDialog>

    <download-dialog
      v-if="isActiveDownload"
      :active="isActiveDownload"
      :surveyId="$route.params.SurveyId"
      @dialog:close="isActiveDownload = false"
    ></download-dialog>
  </v-container>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import answersDialog from "@/views/app/formBuilder/results/AnswersDialog";
import DownloadDialog from "@/views/app/formBuilder/DownloadDialog.vue";

export default {
  components: {
    answersDialog,
    DownloadDialog,
  },

  data: () => ({
    isLoading: false,
    isOpenDialog: false,
    isActiveDownload: false,
    // For pagination
    totalItems: 0,
    options: {
      page: 1,
      itemsPerPage: 15,
    },
    // End for pagination
    userAnswers: [],
    pricingsList: [],
    eventToEdit: {},
    search: "",
    headers: [
      {
        text: "Formulario",
        align: "left",
        value: "user.name",
        class: "primary--text",
        width: "50%",
      },
      //   {
      //     text: "Prefijo",
      //     align: "left",
      //     value: "prefix",
      //     class: "primary--text",
      //     width: "10%",
      //   },
      //   {
      //     text: "Longitud",
      //     value: "longitud",
      //     class: "primary--text",
      //     width: "10%",
      //   },
      //   {
      //     text: "Valor",
      //     value: "value",
      //     class: "primary--text",
      //     width: "15%",
      //   },
      //   {
      //     text: "Tipo",
      //     value: "bill_type",
      //     class: "primary--text",
      //     width: "15%",
      //   },
      {
        text: "Estado",
        align: "left",
        value: "state",
        class: "primary--text",
        width: "20%",
      },
      {
        text: "Creado",
        align: "left",
        value: "created_at",
        class: "primary--text",
        width: "15%",
      },
      {
        text: "Acciones",
        value: "action",
        class: "primary--text",
        width: "15%",
        align: "left",
        sortable: false,
      },
    ],
  }),

  watch: {
    options: {
      handler() {
        this.getSurveyAnswered();
      },
      deep: true,
    },
  },

  created() {
    this.getSurveyAnswered();
  },

  methods: {
    closeFormDialog() {
      this.isOpenDialog = false;
      this.userAnswers = [];
    },

    handleShow(data) {
      this.userAnswers = data;
      this.isOpenDialog = true;
    },

    handleComplete(userID) {
      this.$router.push({
        name: "Completar formulario",
        params: { surveyID: this.$route.params.SurveyId, userID },
      });
    },

    //     async handleDelete(event) {
    //       // const accessToken = localStorage.getItem("token");

    //       try {
    //         const confirmRequest = await this.$swalconfirm(
    //           "Confirmar",
    //           `Está seguro de eliminar este evento? Ésta acción no es reversible.`
    //         );
    //         if (confirmRequest.isConfirmed) {
    //           PbxHttpClient.delete(`/clients/tarificador/${event.id}`)
    //             .then((res) => {
    //               const index = this.pricingsList.findIndex(
    //                 (el) => el.id === res.data.Troncal
    //               );
    //               this.pricingsList.splice(index, 1);

    //               this.$snotify.success("Troncal eliminado", "¡Hecho!");
    //             })
    //             .catch((error) => {
    //               console.error(error);
    //               this.$snotify.error("Hubo un error al eliminar.", "Error");
    //             });
    //         }
    //       } catch (error) {
    //         this.$snotify.error("No se pudo eliminar el troncal.", "¡Error!");
    //         console.error(error);
    //       }
    //     },

    //     closeFormDialog(data = false) {
    //       if (data && this.isEditMode)
    //         this.pricingsList = this.pricingsList.map((el) =>
    //           el.id === data.id ? data : el
    //         );
    //       if (data && !this.isEditMode)
    //         this.pricingsList = [...this.pricingsList, data];
    //       this.isOpenDialog = false;
    //       this.isEditMode = false;
    //       this.eventToEdit = {};
    //     },

    async getSurveyAnswered() {
      this.isLoading = true;

      const payload = this.$route.params.SurveyId;

      const { page, itemsPerPage } = this.options;

      await PbxHttpClient.get(`/surveys/response_survey`, {
        params: { survey_id: payload, page, itemPerPage: itemsPerPage },
      })
        .then((res) => {
          this.pricingsList = res.data.data;
          this.totalItems = res.data.total;
        })
        .catch((error) => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style></style>
